import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
    Dialog, DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
  } from '@/components/ui/dialog'
  import {Button} from "@/components/ui/button";
  import TablesService from "@/services/tables/tables.service";
  import useEventsBus from "@/utils/eventBus";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteDialog',
  props: {
    aId: {},
    object: {},
    entity: {},
    open: { type: Boolean },
    setOpen: {}
  },
  setup(__props: any) {

  const props = __props

  const { emit } = useEventsBus();

  async function deleteRecord(entity: string, id?: number) {
    if (id && entity === 'attachments') {
      await TablesService.deleteRecord(id, entity);
    }
    if (id) {
      emit('delete_'+props.entity, id);
    } else if (props.aId) {
      emit('delete_aDocuments', props.aId)
    } else if (props.object) {
      emit('delete_'+props.entity, props.object);
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: props.open,
    "onUpdate:open": props.setOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('table.delete')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(DialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('table.delete_description')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogClose), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    type: "button",
                    variant: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.cancel')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(DialogClose), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteRecord( props.entity, props.object?.id ))),
                    type: "button",
                    variant: "destructive"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.confirm')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open", "onUpdate:open"]))
}
}

})